<template>
  <div
    class="checkbox-input flex flex-1 items-center"
    :class="[
      props.size === 'sm' ? 'gap-3' : 'gap-2.5',
      props.disabled && 'pointer-events-none cursor-not-allowed opacity-50',
    ]"
    @click="!props.disabled && props.slotIsClickable && emit('update:modelValue', !props.modelValue)"
  >
    <SimpleButton
      class="button rounded-md!"
      :class="[
        props.modelValue && 'pressed',
        props.size === 'sm'
          ? ['size-4! shadow-none! transition-none! [&_svg]:size-3 [&_svg]:text-[0.75rem]',
            props.modelValue ? 'border-accent! bg-accent! text-on-accent!' : 'border-line! bg-input!']
          : 'size-6',
      ]"
      @click="!props.disabled && !props.slotIsClickable && emit('update:modelValue', !props.modelValue)"
    >
      <IconCheck16Solid v-if="props.modelValue" class="shrink-0 text-xl"></IconCheck16Solid>
    </SimpleButton>
    <div class="label w-0 flex-1 overflow-hidden">
      <slot></slot>
    </div>
    <div class="shrink-0">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import SimpleButton from './SimpleButton.vue';
import { IconCheck16Solid } from '@iconify-prerendered/vue-heroicons';

const props = defineProps({
  disabled: {
    default: false,
    type: Boolean,
  },
  modelValue: {
    default: false,
    type: Boolean,
  },
  slotIsClickable: {
    default: true,
    type: Boolean,
  },
  size: String,
})

const emit = defineEmits(['update:modelValue'])
</script>

